export default __webpack_public_path__ + "static/media/annal-full.bacdc62c.svg";